import DateBox from './src/DateBox'

DateBox.install = function (Vue) {
    Vue.component(DateBox.name, DateBox);
};

export default DateBox;